const feedGetters = () => {
    return {
        // getFeedLeague(state) {
        //     return state.feedLeague;
        // },
        getVersion(state) {
            return state.version;
        },
        getFeedTeam(state) {
            return state.feedTeam;
        },
        getMarketName(state) {
            return state.marketName;
        },
        getExtraFeeds(state) {
            return state.extraFeeds;
        },
        getGamesIdx(state) {
            return state.gamesIdx[state.repositoryName];
        },
    };
};

export default feedGetters;
